const data = [
  'FIRST APPOINTMENT',
  'FIRST PROMOTION',
  'FIRST SALARY',
  'LAST SALARY',
  'OTHERS',
];

export default data;
